module.exports = __webpack_public_path__ + "img/SKP.4f75adde.png";